import {
  Box,
  HStack,
  Menu,
  MenuButton,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { MenuPortal } from "shared/components/menu/MenuPortal";
import { ChevronDownIcon } from "shared/icons/ChevronDownIcon";

export interface TableBoxTitleMenuProps {
  title: string;
}

export const TableBoxTitleMenu: React.FC<
  React.PropsWithChildren<TableBoxTitleMenuProps>
> = ({ title, children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Menu
      onOpen={onOpen}
      onClose={onClose}
      offset={[0, 0]}
      isLazy={true}
      lazyBehavior="unmount"
    >
      <MenuButton
        as={Box}
        cursor="pointer"
        sx={{
          borderRadius: "4px",
          px: "4px",
          mx: "-4px",
          _hover: {
            bg: "gray.100",
          },
        }}
      >
        <HStack spacing="4px">
          <Box>{title}</Box>
          <ChevronDownIcon
            width="20px"
            height="20px"
            transform="auto"
            transitionProperty="common"
            transitionDuration="normal"
            rotate={isOpen ? -180 : 0}
          />
        </HStack>
      </MenuButton>
      <MenuPortal>
        <MenuList
          minW="320px"
          py="0"
          sx={{
            ".chakra-menu__menuitem": {
              textStyle: "body",
              minH: "40px",
              flexDirection: "row",
              justifyContent: "space-between",
              py: "10px",
              px: "16px",
              svg: {
                w: "20px",
                h: "20px",
                color: "primary.500",
              },
            },
          }}
        >
          {children}
        </MenuList>
      </MenuPortal>
    </Menu>
  );
};
